import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { Router } from '@angular/router';

@Component({
  selector: 'app-terms-condition',
  templateUrl: './terms-condition.component.html',
  styleUrls: ['./terms-condition.component.css']
})
export class TermsConditionComponent implements OnInit {

ShowCard:any;
constructor(
  private titleService: Title, private metaService: Meta,
      private renderer: Renderer2, @Inject(DOCUMENT) private document: Document, private router:Router
){

}
   
ngOnInit(): void {
   this.setMetaTags();
    this.setCanonicalUrl();
}

 private setMetaTags(): void {
        // Set page title (works for both server and client)
        this.titleService.setTitle('Terms and condition | FA Check');
       
        // Update or add meta tags
        this.metaService.updateTag({ name: 'description', content: 'FA Check terms and conditions outline usage policies, rights, and responsibilities for a secure experience.' });
        // this.metaService.updateTag({ name: 'author', content: 'Your Name' });
       
        // For keywords, use updateTag with proper attribute
//         this.metaService.updateTag({ name: 'keywords', content: 'Association Management Solution, Association Management Software, Best Association Management Solution'
//  });
       
        // Open Graph tags
        this.metaService.updateTag({ property: 'og:title', content: 'Terms and condition | FA Check' });
        this.metaService.updateTag({ property: 'og:description', content: 'FA Check terms and conditions outline usage policies, rights, and responsibilities for a secure experience.' });
        this.metaService.updateTag({ property: 'og:url', content: `https://facheck.in${this.router.url}` });
        this.metaService.updateTag({ property: 'og:type', content: 'website' });
       
        // Twitter tags
        this.metaService.updateTag({ name: 'twitter:title', content: 'Terms and condition | FA Check' });
        this.metaService.updateTag({ name: 'twitter:description', content: 'FA Check terms and conditions outline usage policies, rights, and responsibilities for a secure experience.' });
        this.metaService.updateTag({ name: 'twitter:card', content: 'summary_large_image' });
       
        // You can also add tags if they don't exist
        // this.addTagIfNotExists('og:image', { property: 'og:image', content: 'https://quickrentpay.com/assets/images/og-image.jpg' });
        // this.addTagIfNotExists('twitter:image', { name: 'twitter:image', content: 'https://quickrentpay.com/assets/images/twitter-image.jpg' });
    }
 
 setCanonicalUrl(): void {
    // Remove query parameters for clean canonical URL
    const cleanUrl = this.router.url.split('?')[0];
    const canonicalUrl = `https://facheck.in${cleanUrl}`;
   
    // Use the same DOM manipulation on both server and client
    this.updateCanonicalLink(canonicalUrl);
  }
 
  private updateCanonicalLink(url: string): void {
    // Find existing canonical link
    const existingLink = this.document.querySelector("link[rel='canonical']");
   
    if (existingLink) {
      // Update existing link if href is different
      const currentHref = existingLink.getAttribute('href');
      if (currentHref !== url) {
        this.renderer.setAttribute(existingLink, 'href', url);
      }
    } else {
      // Create new canonical link if it doesn't exist
      const link = this.renderer.createElement('link');
      this.renderer.setAttribute(link, 'rel', 'canonical');
      this.renderer.setAttribute(link, 'href', url);
      this.renderer.appendChild(this.document.head, link);
    }
  }
}
